import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en/index';
import { frCA } from './fr-CA/index';

export const knbrCheckoutTranslations: TranslationResources = {
  en,
  fr_CA: frCA,
};

export const knbrCheckoutTranslationChunksConfig: TranslationChunksConfig = {
  checkout: [
    'checkoutAddress',
    'checkoutReview',
    'checkoutShipping',
    'checkoutType',
    'checkoutPO',
    'checkoutProgress',
    'checkoutMode',
    'orderCost',
  ],
  payment: ['paymentForm', 'paymentMethods', 'paymentCard', 'paymentTypes'],
};
